import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";

interface Delays {
  today_delay: number;
  today_on_time: number;
  last_weeks_delay_avg: number;
  last_weeks_on_time_avg: number;
  last_weekday_delay_avg: number;
  last_weekday_on_time_avg: number;
  region?: string;
}

export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);

  const [todayDelay, setTodayDelay] = useState<number[]>([]);
  const [todayOnTime, setTodayOnTime] = useState<number[]>([]);
  const [todayTotal, setTodayTotal] = useState<number[]>([]);
  const [lastWeeksDelayAvg, setLastWeeksDelayAvg] = useState<number[]>([]);
  const [lastWeeksOnTimeAvg, setLastWeeksOnTimeAvg] = useState<number[]>([]);
  const [lastWeeksTotal, setLastWeeksTotal] = useState<number[]>([]);
  const [lastWeekdayDelayAvg, setLastWeekdayDelayAvg] = useState<number[]>([]);
  const [lastWeekdayOnTimeAvg, setLastWeekdayOnTimeAvg] = useState<number[]>([]);
  const [lastWeekdayTotal, setLastWeekdayTotal] = useState<number[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [dayOfWeek, setDayOfWeek] = useState<string>("");
  const [gramaticalCorrection, setGramaticalCorrection] = useState<string>("");

  useEffect(() => {
    const today= new Date();
    const day = today.getDay();
    const weekday = today.toLocaleString('pt-br', {  weekday: 'long' }).split('-');
    if(day === 0 || day === 6) {
      setGramaticalCorrection("o");
      setDayOfWeek(`${weekday[0]}s`);
    } else {
      setGramaticalCorrection("a");
      setDayOfWeek(`${weekday[0]}s-${weekday[1]}s`);
    }
    setTodayDelay(
      data.delays.map(function (route: Delays) {
        return route.today_delay;
      })
    );
    setTodayOnTime(
      data.delays.map(function (route: Delays) {
        return route.today_on_time;
      })
    );
    setLastWeeksDelayAvg(
      data.delays.map(function (route: Delays) {
        return route.last_weeks_delay_avg;
      })
    );
    setLastWeeksOnTimeAvg(
      data.delays.map(function (route: Delays) {
        return route.last_weeks_on_time_avg;
      })
    );
    setLastWeekdayDelayAvg(
      data.delays.map(function (route: Delays) {
        return route.last_weekday_delay_avg;
      })
    );
    setLastWeekdayOnTimeAvg(
      data.delays.map(function (route: Delays) {
        return route.last_weekday_on_time_avg;
      })
    );
    setCategories(
      data.delays.map(function (route: Delays) {
        return route.region ? route.region : '';
      })
    );
    // O ApexCharts, atualmente, não consegue exibir o total de grupos no barChart horizontal de forma natural
    // Portanto é necessário uma gambiarra para a exibição desses valores
    // O valor 5 foi escolhido arbitrariamente pra definir o "espaço" de exibição do valor total após o gráfico.
    // O valor real do total é exibido através da formatação no dataLabel
    setTodayTotal(
      data.delays.map(function (route: Delays) {
        if(Number(route.today_delay) + Number(route.today_on_time) === 0)
          return Number(route.today_delay) + Number(route.today_on_time)
        else
          return 5;
      })
    );
    setLastWeeksTotal(
      data.delays.map(function (route: Delays) {
        if(Number(route.last_weeks_delay_avg) + Number(route.last_weeks_on_time_avg) === 0)
          return Number(route.last_weeks_delay_avg) + Number(route.last_weeks_on_time_avg)
        else
          return 5;
      })
    );
    setLastWeekdayTotal(
      data.delays.map(function (route: Delays) {
        if(Number(route.last_weekday_delay_avg) + Number(route.last_weekday_on_time_avg) === 0)
          return Number(route.last_weekday_delay_avg) + Number(route.last_weekday_on_time_avg)
        else
          return 5;
      })
    );
  }, [data]);

  const series = [
    {
      name: "Dia Atual - No horário",
      group: 'day',
      data: todayOnTime,
    },
    {
      name: "Dia Atual - Fora do horário",
      group: 'day',
      data: todayDelay,
    },
    {
      name: "Dia Atual - Total",
      group: 'day',
      data: todayTotal,
    },
    {
      name: "Histórico Últimas 4 Semanas - No horário",
      group: 'weeks',
      data: lastWeeksOnTimeAvg,
    },
    {
      name: "Histórico Últimas 4 Semanas - Fora do horário",
      group: 'weeks',
      data: lastWeeksDelayAvg,
    },
    {
      name: "Histórico Últimas 4 Semanas - Total",
      group: 'weeks',
      data: lastWeeksTotal,
    },
    {
      name: "Média Histórica Dias - No horário",
      group: 'weekday',
      data: lastWeekdayOnTimeAvg,
    },
    {
      name: "Média Histórica Dias - Fora do horário",
      group: 'weekday',
      data: lastWeekdayDelayAvg,
    },
    {
      name: "Média Histórica Dias - Total",
      group: 'weekday',
      data: lastWeekdayTotal,
    },
  ];

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    colors: ["#0353ac", "#fd6763", "transparent"],
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    responsive: [
      {
        breakpoint: 480,
      },
    ],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, config) {
        if(config.seriesIndex === 2) 
          return `${config.globals.stackedSeriesTotalsByGroups[0][config.dataPointIndex] - 5}`
        else if(config.seriesIndex === 5) 
          return `${config.globals.stackedSeriesTotalsByGroups[1][config.dataPointIndex] - 5}`
        else if(config.seriesIndex === 8) 
          return `${config.globals.stackedSeriesTotalsByGroups[2][config.dataPointIndex] - 5}`
        else
          return `${val}` ;
      },
    },
    plotOptions: {
      bar: {
        barHeight: "90%",
        horizontal: true,
      },
    },
    xaxis: {
      categories: categories,
      type: 'category',
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        maxWidth: 250
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    legend: { show: false },
    fill: {
      opacity: 1,
    },
    tooltip: {
      enabledOnSeries: [0,1,3,4,6,7],
      x: {
        formatter: function(value, { seriesIndex }) {
          if(seriesIndex < 2) {
            return `${value} </br> Dia Atual`
          } else if(seriesIndex < 5) {
            return `${value} </br> Histórico Últimas 4 Semanas`
          } else if(seriesIndex < 8) {
            return `${value} </br> Média Histórica Últim${gramaticalCorrection}s 4 ${dayOfWeek}`
          } else {
            return `${value}`;
          }
        }
      },
      y: {
        formatter: function (value, { seriesIndex, dataPointIndex}) {
          if(seriesIndex === 0) {
            return `${(Number(todayOnTime[dataPointIndex])/(Number(todayOnTime[dataPointIndex]) + Number(todayDelay[dataPointIndex])) * 100).toFixed(2)}%`
          } else if(seriesIndex === 1) {
            return `${(Number(todayDelay[dataPointIndex])/(Number(todayOnTime[dataPointIndex]) + Number(todayDelay[dataPointIndex])) * 100).toFixed(2)}%`
          } else if(seriesIndex === 3) {
            return `${(Number(lastWeeksOnTimeAvg[dataPointIndex])/(Number(lastWeeksOnTimeAvg[dataPointIndex]) + Number(lastWeeksDelayAvg[dataPointIndex])) * 100).toFixed(2)}%`
          } else if(seriesIndex === 4) {
            return `${(Number(lastWeeksDelayAvg[dataPointIndex])/(Number(lastWeeksOnTimeAvg[dataPointIndex]) + Number(lastWeeksDelayAvg[dataPointIndex])) * 100).toFixed(2)}%`
          } else if(seriesIndex === 6) {
            return `${(Number(lastWeekdayOnTimeAvg[dataPointIndex])/(Number(lastWeekdayOnTimeAvg[dataPointIndex]) + Number(lastWeekdayDelayAvg[dataPointIndex])) * 100).toFixed(2)}%`
          } else if(seriesIndex === 7) {
            return `${(Number(lastWeekdayDelayAvg[dataPointIndex])/(Number(lastWeekdayOnTimeAvg[dataPointIndex]) + Number(lastWeekdayDelayAvg[dataPointIndex])) * 100).toFixed(2)}%`
          } else {
            return `${value}`
          }
        },
        title: {
          formatter: function(seriesName) {
            return `${seriesName.split(" - ")[1]}`
          }
        }
      }
    }
  };

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-routes-begin-delays" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-routes-begin-delays", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Gráfico - Rotas: Saídas no Horário x Saídas em Atraso`}
        id="chart-routes-begin-delays"
      />
      <div id="chart">
        <Chart
          type="bar"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};